import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const EmptyStateRoot = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  '& > .MuiSvgIcon-root': {
    fontSize: 64,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2),
  },
}));
